export const isEmptyObject = value => {
  return Object.keys(value).length === 0
}

export function setByPath(obj, key, value) {
  if (obj == null || typeof obj !== 'object' || typeof key !== 'string' || !key) return false

  const path = key.split('.')
  const stack = [{ node: obj, key: path[0] }]
  let i = 0

  while (i < path.length - 1) {
    const { node, key: k } = stack[i]
    if (node == null || typeof node !== 'object' || !Object.hasOwn(node, k)) return false
    stack.push({ node: node[k], key: path[++i] })
  }

  const { node, key: last } = stack[i]
  if (node == null || typeof node !== 'object' || !Object.hasOwn(node, last)) return false

  node[last] = value
  return true
}



// WEBPACK FOOTER //
// ./src/modules/shared/utils/object.js